import React from 'react';

const ProductDescription = ({ description = '' }) => {
    if (!description) return null;

    const items = description
        .split(',')
        .map((item) => item.trim()) // trim early to catch empty ones
        .filter((item) => item.length > 0) // ignore empty after trim
        .map((item, idx) => {
            let cleaned = item
                .replace(/\*/g, 'x')
                .replace(/[^\w\sñÑáéíóúÁÉÍÓÚüÜ/x.]/g, '')
                .replace(/\s+/g, ' ');
            cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
            return (
                <li key={idx} className="d-flex align-items-start gap-2 product-description-item">
                    <span className="text-primary mt-1 product-description-bullet">●</span>
                    <span>{cleaned}</span>
                </li>
            );
        });

    return (
        <div className="product-description-container">
            <strong className="text-uppercase letter-spacing-1 text-muted d-block mb-2 product-description-title">Descripción</strong>
            <ul className="list-unstyled d-flex flex-column gap-1 text-muted product-description-list">
                {items}
            </ul>
        </div>
    );
};

export default ProductDescription;
